import { $http, Constants } from '@/store/actions/constants';

export const BenefitActions = {

    find: ({ commit, state }, search) => {
        return $http.get(url, { ...state.authHeader, params: search });
    },
    get: ({ commit, state }, id) => {
        return $http.get(`${url}/${id}`, state.authHeader);
    },
    edit: ({ state }, data) => {
        return $http.put(`${url}/${data.id}`, data.data, state.authHeader);
    },
    add: ({ commit, state }, data) => {
        return $http.post(`${url}`, data, state.authHeader);
    },
    delete: ({ state }, id) => {
        return $http.delete(`${url}/${id}`, state.authHeader);
    },

    providerInfo: ({ commit, state }) => {
        return $http.get(`${provider_url}/info`, state.authHeader).then(r => {
            if (r.status === 200) {
                commit('SET_PROVIDER', r.data);
            }
        });
    },
    addProviderInfo: ({ commit, state }, data) => {
        return $http.post(`${provider_url}/info`, data, state.authHeader);
    },

    getProviderBenefits: ({ commit, state }) => {
        $http.get(`${provider_url}/list`, state.authHeader).then(r => {
            if (r.status === 200) {
                commit('SET_PROVIDER_BENEFITS', r.data);
            }
        });
    },
    addProviderBenefits: ({ commit, state }, data) => {
        return $http.post(`${provider_url}/add`, data, state.authHeader);
    },

    editProviderBenefits: ({ commit, state }, data) => {
        return $http.put(`${provider_url}/edit/${data.id}`, data.data, state.authHeader);
    },
    deleteProviderBenefits: ({ commit, state }, id) => {
        return $http.delete(`${provider_url}/delete/${id}`, state.authHeader);
    },

    productDetails: ({ state }, id) => {
        return $http.get(`${url}/productDetails/${id}`, state.authHeader);
    },

    activateOffer: ({ state }, data) => {
        return $http.post(`${offer_url}/activate`, data, state.authHeader);
    },
    providerInfoByID: ({ commit, state }, id) => {
        return $http.get(`${provider_url}/info/${id}`, state.authHeader);
    },
    providerRecommendation: ({ state }, provider_id) => {
        return $http.get(`${provider_url}/${provider_id}/recommendations`, state.authHeader);
    },
    addProviderRecommendation: ({ state }, payload) => {
        return $http.post(`${provider_url}/${payload.provider_id}/recommendations`, payload, state.authHeader);
    },
    editProviderRecommendation: ({ state }, payload) => {
        return $http.put(
            `${provider_url}/${payload.provider_id}/recommendations/${payload.id}`,
            payload,
            state.authHeader,
        );
    },
    getProviderRecommendation: ({ state }, payload) => {
        return $http.get(`${provider_url}/${payload.provider_id}/recommendations/${payload.id}`, state.authHeader);
    },
    upvote: ({ state }, payload) => {
        return $http.post(`${offer_url}/upvote`, payload, state.authHeader);
    },
};

const url = `${Constants.BaseURL}/benefit`;
const provider_url = `${Constants.BaseURL}/benefit/provider`;
const offer_url = `${Constants.BaseURL}/benefit/offers`;